export default __webpack_public_path__ + "static/media/acido-hialuronico.24f2e29b.png";